import React from 'react';

import Heading from '../../../generic-components/Heading';

import { LiliTooltip, LiliToolTipColor, TooltipPosition } from '../../../DesignSystem/LiliTooltip/LiliTooltip';
import { ReactComponent as InfoIcon } from '../../../assets/svg/infoIconInitial.svg';

interface ItemProps {
  line1?: string;
  header?: string;
  line2?: string;
  line3?: string;
  id: string;
}
export const ItemLineWithInfo = ({ header, line1, line2, line3, id }: ItemProps) => (
  <div className='flex gap-[4px] mb-[18px]' id={id}>
    <p className='w-fit font-metricR text-xs  text-bw07'>{header}</p>
    <div>
      <InfoIcon data-tooltip-id={`info-${header}`} data-tooltip-position-strategy='fixed' />
      <LiliTooltip
        description=''
        targetId={`info-${header}`}
        position={TooltipPosition.RIGHT}
        color={LiliToolTipColor.White}
        customContent={
          <div className='flex flex-col px-4 py-2'>
            {line1 && <Heading id={line1} title={line1} className='font-metricRMedium text-bw07 text-[13px]' />}
            {line2 && <Heading id={line2} title={line2} className='font-metricR text-bw07 text-[13px]' />}
            {line3 && <Heading id={line3} title={line3} className='font-metricR text-bw07 text-[13px]' />}
          </div>
        }
      />
    </div>
  </div>
);
